module.exports = __webpack_public_path__ + "img/zespol2.fc48ddd9.webp";